import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';

import { emptyObject } from 'ui-components/default-props/empty';

import { messages } from '../../messages';

const NameCell = ({ value, row }) => {
  const { isFirstInSet } = row?.original || emptyObject;

  if (!isFirstInSet) {
    return null;
  }

  return <Text textType={TextType.Paragraph} value={value} />;
};

export const createNameColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'packageSetName',
  Header: <FormattedMessage {...messages.nameColumnHeader} />,
  Cell: NameCell,
  width: 2,
  minWidth: 150,
});
